module.exports = __webpack_public_path__ + "a06acbfba9d9e11e486881f97133dea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/POG LOGO.png
// module id = 837
// module chunks = 0